import axios from 'axios';
import { SDLUtil } from '@/utils';

const setMaintenance = ({ commit }, data) => {
  commit('SET_MAINTENANCE', data);
};

export default {
  async getMaintenance(store) {
    const data = await axios.get(`${SDLUtil.API_URL}/maintenance/latest`);
    setMaintenance(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/maintenance/maintenanceAction.js